import React from 'react';
import { Section } from './ui/Section';
import { Sun, Moon, Zap, Thermometer } from 'lucide-react';
export function SolutionReveal() {
  return <Section className="bg-brand-primary text-white overflow-hidden relative" data-id="element-109">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-110"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-accent/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-111"></div>

      <div className="relative z-10 text-center max-w-4xl mx-auto" data-id="element-112">
        <span className="inline-block py-1 px-3 rounded-full bg-white/10 text-white/90 text-sm font-medium mb-6 border border-white/20" data-id="element-113">
          La Solución
        </span>

        <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-114">
          Biohacking Exprés <br data-id="element-115" />
          <span className="text-brand-accent italic" data-id="element-116">(sin complicarte)</span>
        </h2>

        <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto" data-id="element-117">
          Acá no hay “todo o nada”. Hay un mecanismo simple.
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-118">
          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20" data-id="element-119">
            <div className="text-4xl font-bold text-brand-accent mb-2" data-id="element-120">
              10 min
            </div>
            <h3 className="text-2xl font-serif mb-2" data-id="element-121">Rutina AM/PM</h3>
            <p className="text-white/80" data-id="element-122">
              Micro-acciones al despertar y al dormir.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20" data-id="element-123">
            <div className="text-4xl font-bold text-brand-accent mb-2" data-id="element-124">
              21 días
            </div>
            <h3 className="text-2xl font-serif mb-2" data-id="element-125">Plan Guiado</h3>
            <p className="text-white/80" data-id="element-126">
              Para que no dependas de inspiración, sino de estructura.
            </p>
          </div>
        </div>

        <h3 className="text-xl font-medium mb-8" data-id="element-127">Vas a trabajar 4 perillas:</h3>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-128">
          {[{
          icon: Moon,
          label: 'Sueño'
        }, {
          icon: Thermometer,
          label: 'Regulación Térmica'
        }, {
          icon: Zap,
          label: 'Energía Estable'
        }, {
          icon: Sun,
          label: 'Calma Fisiológica'
        }].map((item, i) => <div key={i} className="flex flex-col items-center gap-3 p-4 rounded-xl bg-white/5 hover:bg-white/10 transition-colors" data-id="element-129">
              <item.icon className="w-8 h-8 text-brand-accent" data-id="element-130" />
              <span className="font-medium" data-id="element-131">{item.label}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}